import { db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import HelperForMetaData from "../../helpers/HelperForMetaData";

export const CreateUserRecord = async (local, generic) => {
  /**
   * Input:
   *  local > Data collected locally
   *  generic > Data recieved from firebase
   */
  const { uid, business } = local;
  const { profile, providerId } = generic;

  let record = {
    businessName: local.business || profile.business || "",
    email: local.email || profile.email || "",
    uid: local.uid,
    name: local.name || profile.name || "",
    picture: profile.picture || "",
    verified_email: profile.verified_email || false,
    verification_email_sent:
      profile.verified_email || profile.verification_email_sent || false,
    // email_verified: profile.verified_email || false,
    password_update_email_sent: true,
    phoneNumber: local.phoneNumber || "",
    providerId,
    password: local.password || "",
    ...HelperForMetaData(),
    role:
      business == null &&
      (providerId === "password" || providerId === "firebase")
        ? "agent"
        : "admin",
    // role: business == null && providerId === "password" ? "agent" : "admin",
  };
  // If it's an agent, put the business id in the document
  if (business == null) record = { ...addBusinessId(record, local) };

  const usersDoc = await doc(db, "users", uid);
  return await setDoc(usersDoc, record)
    .then((res) => true)
    .catch((err) => false);
};

const addBusinessId = (record, local) => {
  let bid = "";
  if (window.location.pathname.includes("::"))
    bid = window.location.pathname.split("/").pop().split("::").shift();
  else bid = local.bid;

  return {
    ...record,
    bid,
    aid: local.aid || "",
  };
};
